import React, { useReducer, useState } from "react";
import "./scolarite.scss";
import Delete from "../../../component/dialog/delete/Delete.tsx";
import UpdateScolarite from "./UpdateSchoolYear.tsx";
import UpdateClass from "./UpdateClass.tsx";
import toast from "react-hot-toast";
import {
  classeType,
  requestType,
  schooYearType,
} from "../../../types/GlobalType.ts";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller.js";
import { accountService } from "../../../_services/accountServices.js";
import MyLoading from "../../../component/loader/MyLoading.tsx";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import { Tooltip } from "@mui/material";
import { CancelRounded, CheckCircle } from "@mui/icons-material";
import { orderBy } from "lodash";
import { useNavigate } from "react-router-dom";
import ConnexionErrorDiv from "../../../component/nodata/ConnexionErrorDiv.js";

const Scolarite = () => {
  const [yearData, setyearData] = useState("");
  const [classeDesignation, setclasseDesignation] = useState("");
  const [classeCode, setclasseCode] = useState("");

  const [dataSY, setDataSY] = useState<schooYearType[]>([]);
  const [singleDataSY, setSingleDataSY] = useState<schooYearType>();

  const [dataClasses, setDataClasses] = useState<classeType[]>([]);
  const [singleDataClasse, setsingleDataClasse] = useState<classeType>();

  const [itemId, setItemId] = useState<string | number>();
  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);

  const [, setIsValid] = useState<boolean>();
  const [openDeleteYear, setOpenDeleteYear] = React.useState<Boolean>(false);
  const [openDeleteArchive, setopenDeleteArchive] =
    React.useState<Boolean>(false);
  const [openActivateClasse, setopenActivateClasse] =
    React.useState<Boolean>(false);
  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);
  const [openUpdateSchoolYear, setopenUpdateSchoolYear] =
    React.useState<boolean>(false);
  const [openUpdateClass, setopenUpdateClass] = React.useState<boolean>(false);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const navigate = useNavigate();

  const regex = /^\d{4}-\d{4}$/;

  const handleChange = (event) => {
    const value = event.target.value;
    setyearData(value);
  };

  const handleSubmitSY = async () => {
    if (yearData.toString().length < 1) {
      setState({
        isLoading: false,
        errorMessage: "Veuiller complétez l'année",
      });
      return toast.error("Veuiller complétez l'année");
    }

    // Check if the format is valid
    if (regex.test(yearData)) {
      const [firstYear, secondYear] = yearData.split("-").map(Number);
      // Check if the second year is greater than the first
      setIsValid(secondYear > firstYear);
    } else {
      setIsValid(false);
      return toast.error("Année scolaire entrée est invalide");
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    API_CONFIG.ANNEE_SCOLAIRE.create({ designation: yearData }, token)
      .then((response) => {
        // console.log(response);
        if (response.status === 201) {
          toast.success("Année ajoutée avec succes", { duration: 3000 });
          setyearData("");
          dispatchReload();
        } else {
          setState({
            isLoading: false,
            errorMessage:
              "Une erreur inconnue est survenue, réessayer plus tard",
          });
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard88888888",
          );
        }
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        }

        catchErrorApiCall(err);
      });
  };
  const handleAddClasse = async () => {
    if (classeDesignation.toString().length < 1) {
      return toast.error("Veuiller complétez la désignation de la classe", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
        },
      });
    }
    if (classeCode.toString().length < 1) {
      return toast.error("Veuiller complétez le code de la classe", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
        },
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let data = {
        designation: classeDesignation.toUpperCase(),
        code: classeCode.toUpperCase(),
      };
      const response = await API_CONFIG.CLASSE.create(data, token);
      if (response.data.status === 201) {
        toast.success("Classe ajoutée avec succes", { duration: 3000 });
        setclasseCode("");
        setclasseDesignation("");
        dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
          },
        });
      }
    } catch (error) {
      // console.log(error);
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const fetchAllSY = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    API_CONFIG.ANNEE_SCOLAIRE.getAll(token)
      .then((response) => {
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        setDataSY(response.data.data);
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        }

        catchErrorApiCall(err);
      });
  };
  const fetchAllClasses = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.CLASSE.getAll(token);
      setDataClasses(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const handleDeleteSY = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.ANNEE_SCOLAIRE.delete(id, token);
      setLoadingDeleteBtn(false);
      setOpenDeleteYear(false);
      dispatchReload();
      toast.success("Suppression effectuée avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const handleArchiveClasse = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.CLASSE.desactive(id, token);
      setLoadingDeleteBtn(false);
      setopenDeleteArchive(false);
      dispatchReload();
      toast.success("Classe archivée avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      // console.log(error);
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleActivateClasse = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.CLASSE.active(id, token);
      setLoadingDeleteBtn(false);
      setopenActivateClasse(false);
      dispatchReload();
      toast.success("Classe activée avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  let sortedData: classeType[] = [];
  if (dataClasses.length > 0) {
    sortedData = orderBy(dataClasses, ["classe_designation"], ["asc"]);
  }

  React.useEffect(() => {
    fetchAllSY();
    fetchAllClasses();
  }, [stateReload]);

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <div className="topScolarite">
          <MyLoading isLoading={state.isLoading} />
          <div className="card_Year">
            <h2 className="card-title">Année scolaire</h2>
            <div className="input-container">
              <input
                type="text"
                placeholder="Ex: 2014-2015"
                className="input-field"
                value={yearData}
                onChange={handleChange}
                disabled
              />
              {/* <button className="add-button" onClick={handleSubmitSY}>
              {"Ajouter"}
            </button> */}
            </div>
            <ul className="item-list">
              {dataSY.map((value, index) => {
                return (
                  <li key={index}>
                    <span>{value.annee_scolaire_designation}</span>
                    <div className="actionSection">
                      <span
                        className="edit"
                        onClick={() => {
                          // setSingleDataSY(value);
                          // setopenUpdateSchoolYear(true);
                        }}
                      >
                        Edit
                      </span>
                      <span
                        className="archive"
                        onClick={() => {
                          // setItemId(value.annee_scolaire_id);
                          // setOpenDeleteYear(true);
                        }}
                      >
                        Sup
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="card_Classe">
            <h2 className="card-title">Classes</h2>
            <div className="input-container">
              <input
                type="text"
                placeholder="Ex: 4 Scientifique A"
                value={classeDesignation.toUpperCase()}
                onChange={(e) => setclasseDesignation(e.target.value)}
                className="input-field"
              />
              <input
                type="text"
                placeholder="Ex: 4 SC/A"
                value={classeCode.toUpperCase()}
                onChange={(e) => setclasseCode(e.target.value)}
                className="input-field"
              />
              <button className="add-button" onClick={handleAddClasse}>
                Ajouter
              </button>
            </div>
            <div className="table_component" role="region">
              <table>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Désignation</th>
                    <th>Code</th>
                    <th>Status</th>
                    <th className="actionHeader">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.classe_designation}</td>
                      <td>{item.code}</td>
                      <td>
                        <span>
                          {item.classe_status ? (
                            <Tooltip title="Activé" placement="left">
                              <CheckCircle
                                style={{ color: "#28a745", fontSize: "14px" }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Archivé" placement="left">
                              <CancelRounded
                                style={{ color: "#7f1d18", fontSize: "14px" }}
                              />
                            </Tooltip>
                          )}
                        </span>
                      </td>
                      <td className="actionSection">
                        <span
                          className="edit"
                          onClick={() => {
                            setsingleDataClasse(item);
                            setopenUpdateClass(true);
                          }}
                        >
                          Edit
                        </span>
                        {item.classe_status ? (
                          <span
                            className="archive"
                            onClick={() => {
                              setItemId(item.classe_id);
                              setopenDeleteArchive(true);
                            }}
                          >
                            Archiver
                          </span>
                        ) : (
                          <span
                            className="archive"
                            onClick={() => {
                              setItemId(item.classe_id);
                              setopenActivateClasse(true);
                            }}
                          >
                            Activer
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {openUpdateSchoolYear && (
        <UpdateScolarite
          setOpen={setopenUpdateSchoolYear}
          data={singleDataSY}
          dispatchReload={dispatchReload}
        />
      )}
      {openUpdateClass && (
        <UpdateClass
          setOpen={setopenUpdateClass}
          data={singleDataClasse}
          dispatchReload={dispatchReload}
        />
      )}

      {openDeleteYear && (
        <Delete
          setOpen={setOpenDeleteYear}
          itemId={itemId}
          label={"Voulez-vous vraiment supprimer cette année?"}
          handleDelete={handleDeleteSY}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
        />
      )}
      {openDeleteArchive && (
        <Delete
          setOpen={setopenDeleteArchive}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver cette classe?"}
          handleDelete={handleArchiveClasse}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
        />
      )}
      {openActivateClasse && (
        <Delete
          setOpen={setopenActivateClasse}
          itemId={itemId}
          label={"Voulez-vous activer cette classe?"}
          handleDelete={handleActivateClasse}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
    </>
  );
};

export default Scolarite;
